var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("yxtbiz-group-org-select", {
    attrs: {
      placeholder: _vm.$t("pc_biz_chooseOrgId" /* 请选择可以观看直播的平台 */),
      multiple: "",
      selected: _vm.value,
      functionCode: "group_task_center",
      dataPermissionCode: "task_manage_platform",
    },
    on: {
      change: _vm.change,
      "update:selected": function ($event) {
        _vm.value = $event
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }